import {OrgRequestList, OrgRequestRestControllerApiFactory} from "arteco-api-client-ts";
import AppList, {AppListConfig} from "../../../../components/layout/list";
import {SoftChip, PersonAvatar, euros} from "../../../../components/kit";
import {Box, Stack, Typography} from "@mui/material";
import {ORG_REQUEST_STATUS} from "../labels";
import {TableCell} from "@mui/material";
import {useApiManager} from "../../../../components/utils/api";
import {COLOR_DISMISSED} from "../../../../components/layout/colors";

export const OrgRequestListPage = () => {
    const apiManager = useApiManager();

    const listConfig: AppListConfig<OrgRequestList> = {
        title: "Oportunidades",
        onClick: "/app/admin/marketing/org-request",
        headers: [
            {title: "Fecha"},
            {title: "Título"},
            {title: "Organización"},
            {title: "Contacto"},
            {title: "Estado"},
            {title: "Importe", align: "right"},
            {title: "Próxima acción"},
            {title: "Cierre"},
        ],
        decorator: (bean: OrgRequestList) => (
            <>
                <TableCell style={{color: bean.dismissed ? COLOR_DISMISSED : ""}}>
                    {bean.requested ?? "-"}
                </TableCell>
                <TableCell>{bean.title ?? "-"}</TableCell>
                <TableCell>{bean.organization?.name ?? "-"}</TableCell>
                <TableCell>{bean.contact?.surnamesAndName ?? "-"}</TableCell>
                <TableCell>{bean.status ? <SoftChip label={ORG_REQUEST_STATUS[bean.status]?.label ?? bean.status} tone={ORG_REQUEST_STATUS[bean.status]?.tone ?? "neutral"}/> : "—"}</TableCell>
                <TableCell align="right" sx={{fontVariantNumeric: "tabular-nums"}}>
                    {bean.amount != null ? euros(bean.amount) : "—"}
                </TableCell>
                <TableCell>{bean.nextActionDate ?? <SoftChip tone="warning" label="Sin fecha"/>}</TableCell>
                <TableCell>{bean.closeDate ?? "-"}</TableCell>
            </>
        ),
        supplier: async (currentPage, size, term, showDismissed) => {
            const ctrl = apiManager.factory(OrgRequestRestControllerApiFactory);
            // OJO con el orden: los parámetros salen en orden de campo del filtro y los del
            // BasicFilter padre (term, showDismissed) van los últimos. Al añadir `status` y
            // `openOnly` a OrgRequestFilters (#11265) se colaron en medio y desplazaron a los
            // dos de atrás; `actionDue` (#11593) sumó otro. Los `undefined` son sort,
            // organizationId, contactId, status, openOnly y actionDue.
            return ctrl.pageOrgRequest(currentPage, size, undefined, undefined, undefined, undefined, undefined, undefined, term, showDismissed);
        },
    };

    return <AppList config={listConfig}/>;
};
